module.exports = __webpack_public_path__ + "static/scale-model-of-breakout-como-in-columbia-missouri-c0de04fd421b63cb8c15e1cad464ba9f.png";